import React from 'react';

import { Grid, makeStyles, Typography, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  comment: {
    fontSize: '14px',
    lineHeight: '21px',
    textAlign: 'left',
  },
  container: {
    paddingTop: '0px',
    [theme.breakpoints.up('lg')]: {
      paddingTop: '20px',
    },
  },
  divider: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      height: 1,
      marginBottom: 15,
      marginTop: 10,
    },
  },
  fullWidth: {
    [theme.breakpoints.down('sm')]: {
      width: '100% !important',
    },
  },
  questionContainer: {
    background: '#F5F5F5',
    borderRadius: '5px',
    padding: '20px',
  },
  title: {
    color: '#172B4D',
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    marginBottom: '10px',
  },
}));

export default ({ question, caseDetails }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  return (
    <div className={`w-100 ${isDesktop && 'top-separator'} ${classes.container}`}>
      <Grid container>
        <Grid item xs={12}>
          <Typography align="left" className={classes.title}>
            {caseDetails.isLawFirmCase ? 'Relevant Information' : 'Your Question'}
          </Typography>
        </Grid>
        <Grid item className="mb-1" xs={12}>
          <div className={classes.questionContainer}>
            <Typography align="left" className={classes.comment} style={{ whiteSpace: 'pre-wrap' }}>
              {question || '-'}
            </Typography>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
